var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-btn",on:{"click":_vm.onclick}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }